<button
	[disabled]="disabled"
	[matMenuTriggerFor]="menu"
	class="m-b-1"
	color="primary"
	mat-button
	mat-raised-button
>
	Actions
	<mat-icon>keyboard_arrow_down</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before">
	<button [matMenuTriggerFor]="taskStatuses" mat-menu-item>
		<span>Change Status</span>
	</button>
	<button
		(click)="openTaskUpdateModal({ changeDueDate: true, title: 'Change Due Date' })"
		mat-menu-item
	>
		<span>Change Due Date</span>
	</button>
	<button
		(click)="openTaskUpdateModal({ changeProject: true, title: 'Assign Project' })"
		mat-menu-item
	>
		<span>Assign Project</span>
	</button>
	<button
		(click)="openTaskUpdateModal({ changeCarrier: true, title: 'Assign Carrier' })"
		mat-menu-item
	>
		<span>Assign Carrier</span>
	</button>
	<button (click)="deleteSelectedTasks()" mat-menu-item>
		<span>Delete</span>
	</button>
	<button
		(click)="openTaskUpdateModal({ changeAssignee: true, title: 'Change Assignee' })"
		*ngIf="isAdminOrOwner"
		mat-menu-item
	>
		<span>Change Assignee</span>
	</button>
</mat-menu>
<mat-menu #taskStatuses="matMenu">
	<button
		(click)="updateStatus(taskStatus.value)"
		*ngFor="let taskStatus of taskStatusList"
		mat-menu-item
	>
		{{ taskStatus.label }}
	</button>
</mat-menu>
